<template>
  <div id="msg-dependencies" v-if="msgCount == 0"></div>
</template>

<script>
	export default {
		data(){
			return {

			}
		},
		computed:{
			msgCount(){
			var type = this.$store.state.toast.type;
			var toast = this.$store.state.toast.content;
			if(toast !== "") {
				var param = { "type":type, message:toast };
				this.$message(param);
			}
			return this.$store.state.toast.count;
			}
		}
	}
</script>